<template>
  <div :class="$style.base">
    <BaseText bold>{{ $t('global.footer') }}</BaseText>
    <BaseToggle
      v-model="hasFooter"
      v-test="'toggleFooter'"
    />
  </div>
</template>

<script
  lang="ts"
  setup
>
import { storeToRefs } from 'pinia';
import { useMarketingStore } from '../../store';

const { hasFooter } = storeToRefs(useMarketingStore());
</script>

<style
  lang="scss"
  module
>
.base {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-top: 1px solid var(--color-border);
  padding-top: $spacing;
  margin-top: $spacing;
}
</style>
